module.exports = __webpack_public_path__ + "static/media/regard.73f537cb.png";